import { useMutation, useQueryClient } from '@tanstack/react-query'
import epsClient from 'enrollment-platform/api/eps.client'

interface UpsertGlobalFlagParams {
  key: string
  value: boolean
}

/**
 * Toggles a GLOBAL-scope feature flag in the EPS PlatformConfigurations store
 * (platform-admin only — mirrors `useUpsertCustomerConfiguration` but for the
 * global scope). Every write is audit-logged on the backend.
 */
export default function useUpsertGlobalFlag() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ key, value }: UpsertGlobalFlagParams) => {
      const response = await epsClient.put(`/admin/configs/global/${key}`, {
        value,
      })
      return response.data
    },
    onSuccess: (_data, { key }) => {
      queryClient.invalidateQueries({ queryKey: ['globalFlag', key] })
    },
  })
}
